import DAppCollectionOverview from "../../modules/dApp/DAppCollectionOverview";

export default DAppCollectionOverview